import React from 'react';
import Modal from '../Base/Modal';
import CopyToClipboard from 'react-copy-to-clipboard';
import KakaoTalkShareButton from '../KakaoTalkShareButton';
import KakaoStoryShareButton from '../KakaoStoryShareButton';

const openFbShare = (url) => {
  window.open(
    `http://www.facebook.com/share.php?u=${encodeURIComponent(url)}`,
    '_blank',
    'menubar=no,status=no,toolbar=no,width=600,height=500'
  );
}

const ShareModal = ({ showModal, hideModal, post, permalink, device }) => {
  return (
    <Modal
      contentLabel="공유하기"
      onRequestClose={hideModal}
    >
      {{
        renderTitle: () => <span>카카오톡 채널 포스트를<br />SNS에 공유해 보세요.</span>,
        renderContent: () => (
          <div>
            <ul className="list_sns">
              { device.getIn(['device', 'type']) === 'mobile' && (
                <li>
                  <KakaoTalkShareButton 
                    profileId={post.getIn(['author', 'profileId'])}
                    postId={post.get('id')}
                    label={`채널 '${post.author.name}'의 게시글을 공유했습니다.${post.title !== '' ? '\n' + post.title : ''}`}
                    image={post.getRepresentationImage()} 
                    webButton={{
                      text: '자세히보기',
                      url: permalink
                    }}
                  />
                </li>
              )}
              <li>
                <KakaoStoryShareButton 
                  device={device}
                  url={permalink} 
                  text="채널"
                />
              </li>
              <li>
                <button type="button" className="btn_sns btn_facebook" onClick={() => openFbShare(permalink)}>
                  <span className="ico_plus" />페이스북
                </button>
              </li>
              <li>
                <CopyToClipboard text={permalink} onCopy={() => alert('URL이 복사되었습니다.')}>
                  <button type="button" className="btn_sns btn_url">
                    <span className="ico_plus" />URL 복사
                  </button>
                </CopyToClipboard>
              </li>
            </ul>
            <div className="info_url">
              <span className="txt_info">URL 공유시, 아래 주소를 복사하세요.</span>
              <div className="url_copy">
                <span className="txt_url">{permalink}</span>
                <CopyToClipboard text={permalink} onCopy={() => alert('URL이 복사되었습니다.')}>
                  <button type="button" className="btn_copy">URL 복사</button>
                </CopyToClipboard>
              </div>
            </div>
          </div>
        )
      }}
    </Modal>
  );
}

export default ShareModal;



// WEBPACK FOOTER //
// ./src/components/ShareModal/index.js